import React, { FormEvent } from 'react';
import ValidatorFormGroup from '../main/validator-form-group';

import {
    CONTRACTUAL_TYPE_LIST,
    ContractualType,
} from '../../store/userDetailsSlice';
import useTranslate from '../useTranslate';

interface Props {
    label: string;
    disabled: boolean;
    value: ContractualType;
    onChange: (event: FormEvent<HTMLSelectElement>) => void;
}

function FieldContractualType(props: Readonly<Props>) {
    const strings = useTranslate('FieldContractualType');

    const list = props.disabled ? [props.value] : CONTRACTUAL_TYPE_LIST;

    const selectedItem = props.value;
    const translatedTypes = strings;

    function renderOption(contractualType: ContractualType) {
        return (
            <option key={contractualType} value={contractualType}>
                {translatedTypes[contractualType]}
            </option>
        );
    }

    return (
        <ValidatorFormGroup label={props.label} hideErrorLabel>
            <select
                disabled={props.disabled}
                className="form-control"
                name="contractual_type"
                onChange={props.onChange}
                value={selectedItem}
                required
            >
                {!list.includes(selectedItem) && renderOption(selectedItem)}
                {list.map(renderOption)}
            </select>
        </ValidatorFormGroup>
    );
}

export default FieldContractualType;
